export default __webpack_public_path__ + "static/5-best-safari-parks-in-kenya-to-explore-661e08ddaa744c8c84950d7d429f5fb1.jpg";